/** Small display helpers shared by the board and the detail sheet. */

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/** "2026-08-19" -> "19 Aug". Parsed by hand to avoid timezone shifting the day. */
export function shortDate(iso: string): string {
  const parts = iso.split('-');
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  if (!month || !day) return iso;
  return `${day} ${MONTHS[month - 1] ?? ''}`.trim();
}

export const PRIORITY_GLYPH: Record<string, string> = {
  highest: '⇑',
  high: '↑',
  medium: '=',
  low: '↓',
  lowest: '⇓',
};

export const TYPE_GLYPH: Record<string, string> = {
  epic: 'E',
  story: 'S',
  bug: 'B',
  task: 'T',
  subtask: '↳',
};

export const TYPE_LABEL: Record<string, string> = {
  epic: 'Epic',
  story: 'Story',
  bug: 'Bug',
  task: 'Task',
  subtask: 'Subtask',
};
